import _ from 'lodash'

// Profile (thánh, nhân vật...) hay bị trùng tên khi chỉ hiện 1 tên theo ngôn ngữ hiện tại (vd
// "Joseph" khớp cả tiếng Anh lẫn tiếng Pháp) - ghép thêm tên gốc, năm sinh (nếu có) và vài tên gọi
// khác theo ngôn ngữ (từ alias_names) để người dùng phân biệt đúng người. Dùng chung cho mọi nơi
// hiển thị profile dạng list/option (LookupField, SaintSelector...).
export default function getProfileIdentifyingHint(item = {}, displayName) {
  const label = displayName ?? item?.common_name ?? item?.name
  const parts = []

  if (item?.name && item.name !== label) parts.push(item.name)
  if (item?.year_of_birth) parts.push(item.year_of_birth)

  const otherNames = _.uniqBy(
    (item?.alias_names || []).filter((a) => a?.name && a.name !== label && a.name !== item?.name),
    'name'
  )
    .slice(0, 2)
    .map((a) => `${_.toUpper(a.language)}: ${a.name}`)
  parts.push(...otherNames)

  return parts.length > 0 ? parts.join(' · ') : null
}
